export default theme => ({
  modalContent: {
    '& strong': {
      color: theme.indigo2
    }
  }
});
